// db/recipient-helpers.ts
var generateRecipientsPreview = (recipients, maxLength) => {
  const flattenedMailAddresses = recipients.flatMap((recipient) => recipient.to);
  const joinedRecipients = flattenedMailAddresses.join(", ");
  if (joinedRecipients.length <= maxLength) {
    return {
      displayedMailAddresses: flattenedMailAddresses,
      allMailAddresses: flattenedMailAddresses,
      displayIdx: flattenedMailAddresses.length,
      truncatedCount: 0
    };
  } else {
    const displayedMailAddresses = [];
    for (let idx = 0; idx < flattenedMailAddresses.length; idx++) {
      const recipient = flattenedMailAddresses[idx];
      if (!recipient)
        continue;
      console.log(
        displayedMailAddresses,
        recipient,
        [...displayedMailAddresses, recipient],
        [...displayedMailAddresses, recipient].join(", ").length,
        maxLength
      );
      if ([...displayedMailAddresses, recipient].join(", ").length > maxLength)
        break;
      displayedMailAddresses.push(recipient);
    }
    const truncatedRecipients = flattenedMailAddresses.slice(displayedMailAddresses.length);
    return {
      displayedMailAddresses,
      allMailAddresses: flattenedMailAddresses,
      displayIdx: displayedMailAddresses.length,
      truncatedCount: truncatedRecipients.length
    };
  }
};
export {
  generateRecipientsPreview
};
